import { Stack, styled } from '@mui/material'
import { memo } from 'react'
import { useLinkConnected } from 'store/link/hooks'
import { SectionTitle, SectionWrap } from 'styles'
import { transientOptions } from 'styles/TransientOptions'
import { BalanceButtonGroup } from './BalanceButtonGroup'
import { BalanceTokenList } from './BalanceTokenList'
import { AssetsEyes } from '../../../components/AssetsEyes'
import { ShowFaucetButton } from '../../../components/Buttons/ShowFaucetButton'

export const BalancesWrap = styled(SectionWrap)`
  position: relative;
  height: 100%;
  padding: 0 16px;
  overflow: auto;
`

export const BalanceTitle = styled('div', transientOptions)<{
  $isLogin: boolean
}>`
  display: flex;
  align-items: center;
  height: 32px;
  color: ${(props) => props.theme.color.text70};
  font-weight: 600;
  font-size: 14px;
  line-height: 1.2;
  padding: 8px 0;
  .iconfont {
    cursor: pointer;
  }
  svg {
    width: 18px;
    height: 18px;
  }
  ${(props) => props.theme.breakpoints.down('md')} {
    height: unset;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    display: ${(props) => (props.$isLogin ? 'flex' : 'none')};
    padding: 10px 20px;
    border: 1px solid ${(props) => props.theme.color.bgGray};
    .iconfont {
      font-size: 20px !important;
      font-weight: 400;
    }
  }
`
export const BalanceTitleSvg = styled('div')(({ theme }) => ({
  display: 'none',
  width: 18,
  height: 18,
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 12,
  [theme.breakpoints.down('md')]: {
    display: 'flex',
  },
}))

export const BalanceInfo = styled('div')`
  margin-bottom: 4px;
  flex: 1;
`

export interface TotalBalanceData {
  [index: string]: TotalBalance
}
export interface TotalBalance {
  currentBalance: string
  openingBalance: string
}
export const Balances = memo(() => {
  const linkConnected = useLinkConnected()

  return (
    <BalancesWrap>
      <SectionTitle justifyContent="space-between">
        <Stack direction="row" spacing={0.5}>
          <span>Assets</span>
          <AssetsEyes />
        </Stack>
        <ShowFaucetButton />
      </SectionTitle>
      <BalanceInfo>
        <BalanceButtonGroup />
        {linkConnected && <BalanceTokenList />}
      </BalanceInfo>
    </BalancesWrap>
  )
})
